function initGallerySliders() {
  var galleries = document.querySelectorAll('.blocks__gallery');

  galleries.forEach(function (gallery) {
    var imageContainer = gallery.querySelector('.blocks__gallery__list');
    var leftArrow = gallery.querySelector('.blocks__gallery__arrow--left');
    var rightArrow = gallery.querySelector('.blocks__gallery__arrow--right');

    if (!imageContainer || !leftArrow || !rightArrow) return;

    var images = Array.from(imageContainer.querySelectorAll('li'));
    if (!images.length) return;

    var currentIndex = 0;

    // Index of the slide that overlaps the visible area the most.
    function getMostVisibleIndex() {
      var view = imageContainer.getBoundingClientRect();
      var bestIndex = 0;
      var bestVisible = -Infinity;

      images.forEach(function (li, i) {
        var rect = li.getBoundingClientRect();
        var visible = Math.min(rect.right, view.right) - Math.max(rect.left, view.left);
        if (visible > bestVisible) {
          bestVisible = visible;
          bestIndex = i;
        }
      });

      return bestIndex;
    }

    function setActive(index) {
      currentIndex = Math.max(0, Math.min(index, images.length - 1));
      images.forEach(function (li, i) {
        li.classList.toggle('active', i === currentIndex);
      });
      leftArrow.classList.toggle('disabled', currentIndex === 0);
      rightArrow.classList.toggle('disabled', currentIndex === images.length - 1);
    }

    function goTo(index) {
      setActive(index);
      var li = images[currentIndex];
      var delta = li.getBoundingClientRect().left - imageContainer.getBoundingClientRect().left;
      imageContainer.scrollTo({ left: imageContainer.scrollLeft + delta, behavior: 'smooth' });
    }

    rightArrow.addEventListener('click', function () {
      goTo(currentIndex + 1);
    });

    leftArrow.addEventListener('click', function () {
      goTo(currentIndex - 1);
    });

    // After a manual scroll settles, sync the active slide to whatever is in
    // view so the next arrow click continues from the right position.
    function onScrollEnd() {
      setActive(getMostVisibleIndex());
    }

    if ('onscrollend' in window) {
      imageContainer.addEventListener('scrollend', onScrollEnd);
    } else {
      var scrollTimer;
      imageContainer.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(onScrollEnd, 120);
      }, { passive: true });
    }

    // Respect any pre-set active slide, otherwise default to the first.
    var initial = images.findIndex(function (li) {
      return li.classList.contains('active');
    });
    setActive(initial === -1 ? 0 : initial);
  });
}

// Usage: call initGallerySliders() after your fetch completes and DOM is updated
initGallerySliders();